import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7f66792a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100vw"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "position": "absolute",
    "width": "100vw",
    "background-color": "#fff5f5",
    "height": "70px",
    "display": "flex",
    "justify-content": "flex-start",
    "align-items": "center",
    "word-break": "break-all",
    "padding": "5px 20px 0 5px"
  }
};
const _hoisted_3 = {
  class: "sale-left"
};
const _hoisted_4 = ["title"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  class: "unread",
  style: {
    "top": "5px",
    "position": "unset",
    "float": "right"
  }
};
const _hoisted_7 = {
  key: 1,
  class: "solveddiv",
  style: {
    "position": "unset"
  }
};
const _hoisted_8 = {
  class: "solved",
  style: {
    "position": "unset",
    "float": "right"
  }
};
const _hoisted_9 = {
  key: 2,
  style: {
    "position": "unset",
    "float": "right"
  },
  class: "unresolve"
};
const _hoisted_10 = {
  class: "time"
};
const _hoisted_11 = {
  class: "dec"
};
const _hoisted_12 = {
  key: 3,
  style: {
    "position": "relative",
    "float": "right",
    "bottom": "10px",
    "/* float": "right",
    "*/\n            /* bottom": "10px",
    "*/\n            /* float": "right",
    "*/\n            /* height": "25px",
    "*/\n            /* right": "0px",
    "*/\n            text-align": "right",
    "width": "100%"
  }
};
const _hoisted_13 = {
  class: "score",
  style: {
    "text-align": "right"
  }
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": ".4rem",
    "background": "#f4f4f4",
    "border-bottom": "1px solid #dadada"
  }
}, null, -1));

const _hoisted_15 = {
  class: "sale-right"
};
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  key: 2,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "start",
    "width": "100%"
  }
};
const _hoisted_18 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_19 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "flex-direction": "column"
  }
};
const _hoisted_20 = {
  key: 0,
  style: {
    "display": "flex",
    "width": "70%",
    "margin": "0 auto"
  }
};
const _hoisted_21 = {
  style: {
    "max-width": "50%",
    "word-break": "break-word"
  }
};
const _hoisted_22 = {
  class: "tool-top"
};
const _hoisted_23 = {
  key: 0,
  class: "tool-botton"
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_icon_WarningFilled = _resolveComponent("el-icon-WarningFilled");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_rate = _resolveComponent("el-rate");

  const _component_van_icon = _resolveComponent("van-icon");

  const _component_el_image_viewer = _resolveComponent("el-image-viewer");

  const _component_templateTicket = _resolveComponent("templateTicket");

  const _component_el_divider = _resolveComponent("el-divider");

  const _component_van_field = _resolveComponent("van-field");

  const _component_van_button = _resolveComponent("van-button");

  const _component_MoblieUpload = _resolveComponent("MoblieUpload");

  const _component_MoblieScorePanel = _resolveComponent("MoblieScorePanel");

  const _component_templateDemoEdit = _resolveComponent("templateDemoEdit");

  const _component_el_container = _resolveComponent("el-container");

  const _directive_loading = _resolveDirective("loading");

  return _withDirectives((_openBlock(), _createBlock(_component_el_container, {
    "element-loading-text": '拼命加载中...' + _ctx.loadingTextArray.join(),
    "element-loading-spinner": "el-icon-loading",
    "element-loading-background": "rgba(0, 0, 0, 0.5)"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_1, [_ctx.noName ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_icon, {
      style: {
        "font-size": "20px",
        "color": "rgb(251,197,80)",
        "margin": "0 20px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon_WarningFilled)]),
      _: 1
    }), _createTextVNode(" " + _toDisplayString(_ctx._t('温馨提示：尊敬的顾客，您现在处于匿名模式，建议您登录账户以便查看聊天记录')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
      class: "ticket",
      title: _ctx._t('unread') + '/' + _ctx._t('unresolved'),
      style: _normalizeStyle({
        'margin-top': _ctx.noName ? '70px' : ''
      })
    }, _toDisplayString(_ctx._t("afterSalesQuestion")) + "(" + _toDisplayString(_ctx.unreadCount_new) + "/" + _toDisplayString(_ctx.unrresolvedCount_new) + ") ", 13, _hoisted_4), _createElementVNode("div", {
      class: _normalizeClass(["problem-group", $data.ticketListExpanded ? 'problem-groupd' : 'problem-groupx'])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionRecordSort_new, (_record, _recordIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: _recordIndex,
        class: _normalizeClass(["problem-div", [_record.id == _ctx.questionRecordId_new ? 'activity' : '']]),
        style: {
          "position": "unset",
          "word-break": "break-all"
        },
        onClick: $event => _ctx.clickQuestionRecord(_record)
      }, [_record.user_unread && _record.is_solved == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), _record.is_solved ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, "[" + _toDisplayString(_ctx._t("solved")) + "]", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_9, "[" + _toDisplayString(_ctx._t("unsolved")) + "] ", 1)), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getLocalTime(_record.create_time)), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, _toDisplayString(_ctx.getNav(_record).join(">") + ">" + _ctx.getTitle(_record)), 1)]), _record.score || _record.score == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createTextVNode(_toDisplayString(_ctx._t('rate')), 1), _createVNode(_component_el_rate, {
        modelValue: _record.score,
        "onUpdate:modelValue": $event => _record.score = $event,
        disabled: "",
        "text-color": "#ff9900"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])])])) : _createCommentVNode("", true)], 10, _hoisted_5);
    }), 128))], 2), _createElementVNode("div", {
      class: "more-btn",
      onClick: _cache[0] || (_cache[0] = $event => $options.clickTicketListExpanded())
    }, [$data.ticketListExpanded ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      name: "/moblie/images/aftersale-top.png"
    })) : (_openBlock(), _createBlock(_component_van_icon, {
      key: 1,
      name: "/moblie/images/aftersale-up.png"
    }))]), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_ctx.imgViewerShow ? (_openBlock(), _createBlock(_component_el_image_viewer, {
      key: 0,
      onClose: _cache[1] || (_cache[1] = $event => _ctx.imgViewerShow = false),
      infinite: false,
      "url-list": _ctx.imgArray,
      "initial-index": _ctx.imgIndex
    }, null, 8, ["url-list", "initial-index"])) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "chat-state d-flex justify-content-between",
      style: {
        "color": "#5dc0ff",
        "background": "#e2f5ff"
      },
      onClick: _cache[2] || (_cache[2] = $event => _ctx.clickSolved(_ctx.questionRecord_new))
    }, _toDisplayString(_ctx.questionRecord_new.is_solved ? _ctx._t("unsolved") : _ctx._t("solved")), 1), _createElementVNode("div", {
      class: "chat",
      ref: "chat",
      style: _normalizeStyle({
        'height': $options.chatHeight
      })
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatReocrd_new, (_chat, _chatIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: _chatIndex,
        class: _normalizeClass(["chatdiv", [!_chat.user?.erpPersonalId ? 'chatdiv-right' : '']])
      }, [_chat.messageType == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: "name",
        style: _normalizeStyle([{
          "flex-basis": "100%"
        }, {
          'text-align': !_chat.user?.erpPersonalId ? 'right' : ''
        }])
      }, [_createElementVNode("span", {
        style: _normalizeStyle({
          'background-color': !_chat.user?.erpPersonalId ? '' : 'rgb(127, 255, 212)'
        })
      }, _toDisplayString(_chat.user?.name) + " [" + _toDisplayString(_ctx.getLocalTime(_chat.time)) + "]", 5)], 4), _createElementVNode("div", {
        class: "txt",
        innerHTML: _chat.new_content
      }, null, 8, _hoisted_16)], 64)) : _createCommentVNode("", true), _chat.messageType == 10 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", {
        class: "name",
        style: _normalizeStyle([{
          "flex-basis": "100%"
        }, {
          'text-align': !_chat.user?.erpPersonalId ? 'right' : ''
        }])
      }, [_createElementVNode("span", {
        style: _normalizeStyle({
          'background-color': !_chat.user?.erpPersonalId ? '' : 'rgb(127, 255, 212)'
        })
      }, _toDisplayString(_chat.user?.name) + " [" + _toDisplayString(_ctx.getLocalTime(_chat.time)) + "]", 5)], 4), _createVNode(_component_templateTicket, {
        tempTicketData: JSON.parse(_chat.content),
        ref_for: true,
        ref: "ticket",
        isAdmin: false,
        onChange: _ctx.callBack
      }, null, 8, ["tempTicketData", "onChange"])], 64)) : _createCommentVNode("", true), _chat.messageType == 6 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_chat.content.score, (item, index) => {
        return _openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_divider, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx._t("inviteScore")), 1)]),
          _: 1
        }), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createVNode(_component_el_rate, {
          modelValue: item.score,
          "onUpdate:modelValue": $event => item.score = $event,
          max: 5,
          disabled: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]), _chat.content.suggest ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", null, _toDisplayString(_ctx._t("yourSuggest")), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(_chat.content.suggest), 1)])) : _createCommentVNode("", true)]);
      }), 256))])) : _createCommentVNode("", true)], 2);
    }), 128))], 4), _createElementVNode("div", {
      class: _normalizeClass(["tool", $data.isToolOpen ? 'tool-open' : ''])
    }, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_van_field, {
      rows: "2",
      placeholder: _ctx.userDisabled ? '' : _ctx._t('sendPlaceholder'),
      modelValue: _ctx.sendContent,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.sendContent = $event),
      disabled: _ctx.userDisabled,
      onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers($event => _ctx.clickSendContent($event), ["exact"]), ["enter"])),
      onKeyup: _cache[5] || (_cache[5] = _withKeys($event => _ctx.sendContent = '', ["enter"])),
      onFocus: _cache[6] || (_cache[6] = $event => $options.focusSendContent($event))
    }, null, 8, ["placeholder", "modelValue", "disabled"]), _createVNode(_component_van_icon, {
      class: "cart-icon",
      size: "22",
      name: "add-o",
      onClick: _cache[7] || (_cache[7] = $event => $options.clickToolOpen())
    }), _createVNode(_component_van_button, {
      class: "input-btn",
      size: "small",
      type: "primary",
      round: "",
      onClick: _cache[8] || (_cache[8] = $event => _ctx.clickSendContent($event)),
      disabled: _ctx.userDisabled
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx._t("send")), 1)]),
      _: 1
    }, 8, ["disabled"])]), $data.isToolOpen ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_MoblieUpload, {
      url: _ctx.uploadUrl,
      onOnSuccess: _ctx.onSuccessUpload,
      disabled: _ctx.userDisabled,
      fileType: "image"
    }, null, 8, ["url", "onOnSuccess", "disabled"]), _createVNode(_component_MoblieUpload, {
      url: _ctx.uploadUrl,
      onOnSuccess: _ctx.onSuccessUpload,
      disabled: _ctx.userDisabled,
      fileType: "file"
    }, null, 8, ["url", "onOnSuccess", "disabled"])])) : _createCommentVNode("", true)], 2), _ctx.scorePanel.show ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_MoblieScorePanel, {
      show: _ctx.scorePanel.show,
      "onUpdate:show": _cache[9] || (_cache[9] = $event => _ctx.scorePanel.show = $event),
      style: {
        "z-index": "2"
      },
      questionRecordSelected: _ctx.questionRecord_new,
      scoreOption: _ctx.scoreOption,
      updateTicketList: _ctx.updateTicketList
    }, null, 8, ["show", "questionRecordSelected", "scoreOption", "updateTicketList"])])) : _createCommentVNode("", true)])], 512), [[_vShow, !_ctx.templateDemoShow]]), _ctx.templateDemoShow ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_templateDemoEdit, {
      dpt: _ctx.damageReportContent,
      userView: _ctx.userView,
      functionTemple: _ctx.functionTemple
    }, null, 8, ["dpt", "userView", "functionTemple"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["element-loading-text"])), [[_directive_loading, _ctx.refresh]]);
}